import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=7ee612fa&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=7ee612fa&prod&lang=scss&scoped=true"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=7ee612fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee612fa",
  null
  
)

export default component.exports